import { customProperties } from "../../constants/colours";
import colorSystem from "../../constants/colours-vars.json";

export const MULTICOLOUR_LINE_COLOURS = (
  Object.keys(colorSystem.legacy.charts) as Array<
    keyof typeof colorSystem.legacy.charts
  >
)
  .sort()
  .map((k) => colorSystem.legacy.charts[k]);

export const MULTICOLOUR_AREA_COLOURS = (
  Object.keys(colorSystem.legacy.chartsHover) as Array<
    keyof typeof colorSystem.legacy.charts
  >
)
  .sort()
  .map((k) => colorSystem.legacy.chartsHover[k]);

// this is used in the top number list where any items beyond the top 10 are
// categorized as "Other" so that we can colour the bar or pie chart along with
// the label
export const OTHER = {
  LABEL: "Other",
  COLOUR: customProperties["--colour-text-200"],
};
